const notFound = r => require.ensure([], () => r(require('../views/404.vue')), 'notFound')
const home = r => require.ensure([], () => r(require('../views/workorder.vue')), 'home')

let routes = [
  { path: '*', redirect: { path: '/404' }, name: '404', hidden: true },
  { path: '/workorder/index.html', redirect: { path: '/workorder' }, hidden: true },
  { path: '/404', component: notFound, name: '404', hidden: true },
  { path: '/workorder', component: home, name: '首页', hidden: true },
  { path: '/', redirect: { path: '/workorder' }, hidden: true }
];

export default routes;


// WEBPACK FOOTER //
// ./src/modules/workorder/router/routes.js